<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  data () {
    return {
    }
  },
  components: {
    // MenuTemp
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  watch: {
  },
  methods: {
  },
  created () {
  }
}
</script>

<style>
@font-face{
  font-family: Rubik;
  src: url("./assets/Rubik-Regular.ttf");
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
}
body,html,#app {
  width: 100%;
  height: auto;
  font-family: 'Rubik';
  font-size: 16px;
  overflow-x: hidden;
  color: #58585A;
  background: #E8EFF3;
}
a{
  color: #58585A;
  text-decoration: none;
}
img {
  display: block;
}
.auto {
  height: auto;
  overflow: hidden;
}
.clear {
  width: 100%;
  height: 0px;
  overflow: hidden;
  clear: both;
}
.ellipsis{
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* font-size */
.font36{
  font-size: 36px;
}
.font30{
  font-size: 30px;
}
.font18{
  font-size: 18px;
}
.font16{
  font-size: 16px;
}
.font14{
  font-size: 14px;
}

/* 盒模型 */
.boxsizing {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}

/* common */
.fl {
  float: left;
}
.fr {
  float: right;
}

</style>



// WEBPACK FOOTER //
// src/App.vue